import React from 'react';
import styled from 'styled-components';

const VoteHeader = () => {
  return <Wrapper> 13기 프론트 엔드 팀장 투표</Wrapper>;
};

export default VoteHeader;

const Wrapper = styled.h1`
  text-align: center;
  font-size: 30px;
`;
